var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInfoButton(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "info-button",
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.957,
    height: 17.957,
    viewBox: "0 0 17.957 17.957",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_38119",
    "data-name": "Path 38119",
    d: "M8.979,0a8.979,8.979,0,1,0,8.979,8.978A8.979,8.979,0,0,0,8.979,0Zm1.373,13.881a1.369,1.369,0,0,1-2.737,0V7.917a1.369,1.369,0,0,1,2.737,0ZM8.979,5.429a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,8.979,5.429Z",
    fill: "#2179fe"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoButton);
export default __webpack_public_path__ + "static/media/info-button.6c5c7380.svg";
export { ForwardRef as ReactComponent };